module.exports = __webpack_public_path__ + "static/media/radioactive-materials.ec9088cd.svg";